import React, { useEffect, useRef, useState } from "react";

function ApartmentBlock1({ rooms }) {
  const svgRef = useRef(null);
  const [roomCenters, setRoomCenters] = useState([]);
  const [clickedRoom, setClickedRoom] = useState(null);

  const handleBlockClick = (pathId) => {
    const room = rooms.find((room) => room.top === pathId);
    if (room) {
     
      setClickedRoom({ pathId, status: room.status });
    }
  };

  useEffect(() => {
    if (svgRef.current) {
      const paths = svgRef.current.querySelectorAll("path");
      const centers = Array.from(paths).map((path) => {
        const bbox = path.getBBox();
        const centerX = bbox.x + bbox.width / 2;
        const centerY = bbox.y + bbox.height / 2;
       
        return { centerX, centerY, pathId: path.id };
      });
      setRoomCenters(centers);
    }
  }, [rooms]);

  return (
    <div className="relative w-full h-full">
      <svg
        viewBox="0 0 1364 927"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        className="w-full h-full"
        ref={svgRef}
      >
        <defs />

        {/* SVG Paths */}
        <path
          id="B1 - 12"
          d="M 850,555 L 849,556 L 849,864 L 1084,864 L 1084,594 L 1053,594 L 1051,592 L 1051,555 Z"
          strokeWidth="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 12")}
          fill={
            clickedRoom?.pathId === "B1 - 12"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#b19e9a"
          }
        />

        <path
          id="B1 - 01"
          d="M 1122,552 L 1122,593 L 1121,594 L 1090,594 L 1089,595 L 1089,864 L 1324,864 L 1324,552 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 01")}
          fill={
            clickedRoom?.pathId === "B1 - 01"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#b19e9a"
          }
        />
        <path
          id="B1 - 02"
          d="M 607,348 L 607,350 L 606,351 L 607,352 L 607,527 L 606,528 L 606,543 L 607,544 L 607,545 L 606,546 L 606,548 L 607,548 L 608,549 L 842,549 L 843,548 L 843,348 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 02")}
          fill={
            clickedRoom?.pathId === "B1 - 02"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c6b6b4"
          }
        />
        <path
          id="B1 - 03"
          d="M 362,348 L 362,549 L 600,549 L 601,548 L 601,544 L 600,543 L 600,352 L 601,351 L 601,349 L 600,348 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 03")}
          fill={
            clickedRoom?.pathId === "B1 - 03"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c6b6b4"
          }
        />
        <path
          id="B1 - 04"
          d="M 850,347 L 849,348 L 849,549 L 1055,549 L 1055,544 L 1053,544 L 1052,543 L 1052,532 L 1053,531 L 1055,531 L 1055,527 L 1054,527 L 1052,525 L 1052,516 L 1054,514 L 1055,514 L 1055,510 L 1053,510 L 1052,509 L 1052,498 L 1053,497 L 1055,497 L 1055,493 L 1054,492 L 1053,492 L 1052,491 L 1052,481 L 1053,480 L 1055,480 L 1055,476 L 1054,476 L 1052,474 L 1052,464 L 1053,463 L 1054,463 L 1055,462 L 1055,459 L 1054,458 L 1053,458 L 1052,457 L 1052,447 L 1053,446 L 1055,446 L 1055,442 L 1054,441 L 1053,441 L 1052,440 L 1052,430 L 1053,429 L 1054,429 L 1055,428 L 1055,424 L 1053,424 L 1052,423 L 1052,413 L 1053,412 L 1055,412 L 1055,408 L 1054,407 L 1053,407 L 1052,406 L 1052,396 L 1054,394 L 1055,394 L 1055,390 L 1053,390 L 1052,389 L 1052,379 L 1053,378 L 1054,378 L 1055,377 L 1055,374 L 1054,373 L 1053,373 L 1052,372 L 1052,361 L 1053,360 L 1055,360 L 1055,356 L 1054,356 L 1052,354 L 1052,348 L 1051,347 Z"
          stroke-width="1"
          
         
          fill="#8a8ca7"
        />
        <path
          id="B1 - 05"
          d="M 1122,318 L 1122,327 L 1123,328 L 1123,335 L 1122,336 L 1122,535 L 1123,536 L 1123,543 L 1122,544 L 1122,545 L 1123,546 L 1324,546 L 1324,318 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 05")}
          fill={
            clickedRoom?.pathId === "B1 - 05"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c1b3b3"
          }
        />
        <path
          id="B1 - 06"
          d="M 43,315 L 43,548 L 44,549 L 356,549 L 356,348 L 355,347 L 330,347 L 329,348 L 327,348 L 326,347 L 315,347 L 314,346 L 314,315 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 06")}
          fill={
            clickedRoom?.pathId === "B1 - 06"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#af9e9c"
          }
        />
        <path
          id="B1 - 07"
          d="M 1123,75 L 1122,76 L 1122,77 L 1123,78 L 1123,79 L 1122,80 L 1122,82 L 1123,83 L 1122,84 L 1122,87 L 1123,88 L 1123,127 L 1122,128 L 1122,239 L 1123,240 L 1123,280 L 1122,281 L 1122,283 L 1123,284 L 1123,286 L 1122,287 L 1123,288 L 1123,311 L 1124,312 L 1125,311 L 1126,311 L 1127,312 L 1128,311 L 1318,311 L 1319,312 L 1320,311 L 1324,311 L 1324,76 L 1323,75 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 07")}
          fill={
            clickedRoom?.pathId === "B1 - 07"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c6b6b4"
          }
        />
        <path
          id="B1 - 08"
          d="M 853,75 L 853,76 L 852,77 L 853,78 L 852,79 L 853,80 L 852,81 L 852,84 L 853,85 L 852,86 L 852,271 L 853,272 L 852,273 L 852,274 L 853,275 L 853,276 L 1116,276 L 1116,75 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 08")}
          fill={
            clickedRoom?.pathId === "B1 - 08"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c6b6b4"
          }
        />
        <path
          id="B1 - 09"
          d="M 607,75 L 607,79 L 606,80 L 606,82 L 607,83 L 607,274 L 606,275 L 607,276 L 846,276 L 846,75 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 09")}
          fill={
            clickedRoom?.pathId === "B1 - 09"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c6b6b4"
          }
        />
        <path
          id="B1 - 10"
          d="M 43,75 L 43,308 L 44,309 L 314,309 L 314,278 L 316,276 L 356,276 L 356,75 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 10")}
          fill={
            clickedRoom?.pathId === "B1 - 10"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#ad9d9b"
          }
        />
        <path
          id="B1 - 11"
          d="M 368,72 L 368,74 L 367,75 L 362,75 L 361,76 L 361,276 L 362,277 L 367,277 L 368,278 L 368,280 L 372,280 L 373,279 L 373,278 L 374,277 L 385,277 L 386,278 L 386,280 L 390,280 L 390,278 L 391,277 L 401,277 L 402,278 L 402,279 L 403,280 L 407,280 L 407,278 L 408,277 L 419,277 L 420,278 L 420,280 L 424,280 L 424,278 L 425,277 L 436,277 L 437,278 L 437,280 L 441,280 L 441,278 L 442,277 L 453,277 L 454,278 L 454,280 L 458,280 L 459,279 L 459,278 L 460,277 L 470,277 L 471,278 L 471,280 L 475,280 L 476,279 L 476,278 L 477,277 L 487,277 L 488,278 L 488,279 L 489,280 L 493,280 L 493,278 L 494,277 L 504,277 L 505,278 L 505,280 L 509,280 L 510,279 L 510,278 L 511,277 L 521,277 L 522,278 L 522,279 L 523,280 L 527,280 L 527,278 L 528,277 L 538,277 L 539,278 L 539,279 L 540,280 L 544,280 L 544,278 L 545,277 L 556,277 L 557,278 L 557,280 L 561,280 L 561,278 L 562,277 L 572,277 L 573,278 L 573,279 L 574,280 L 578,280 L 578,278 L 579,277 L 590,277 L 591,278 L 591,280 L 595,280 L 596,279 L 596,278 L 597,277 L 600,277 L 601,276 L 601,75 L 597,75 L 596,74 L 596,72 L 591,72 L 591,74 L 590,75 L 579,75 L 578,74 L 578,72 L 573,72 L 573,74 L 572,75 L 563,75 L 561,73 L 561,72 L 557,72 L 557,74 L 556,75 L 545,75 L 544,74 L 544,72 L 539,72 L 539,74 L 538,75 L 528,75 L 527,74 L 527,72 L 522,72 L 522,74 L 521,75 L 511,75 L 510,74 L 510,72 L 505,72 L 505,74 L 504,75 L 494,75 L 493,74 L 493,72 L 488,72 L 488,74 L 487,75 L 477,75 L 476,74 L 476,72 L 471,72 L 471,74 L 470,75 L 460,75 L 459,74 L 459,72 L 454,72 L 454,74 L 453,75 L 442,75 L 441,74 L 441,72 L 437,72 L 437,74 L 436,75 L 425,75 L 424,74 L 424,72 L 420,72 L 420,74 L 419,75 L 408,75 L 407,74 L 407,72 L 402,72 L 402,74 L 401,75 L 391,75 L 390,74 L 390,72 L 386,72 L 386,74 L 385,75 L 374,75 L 373,74 L 373,72 Z"
          stroke-width="1"
          fill="#8a8ca7"
        />

        {/* Render status text for each room */}
        {rooms?.map((roomSec, index) => {
          const { unit, room } = roomSec;
          const roomCenter = roomCenters.find(
            (center) => center.pathId === roomSec.top
          );

          return (
            roomCenter && (
              <text
                key={index}
                x={roomCenter.centerX}
                y={roomCenter.centerY}
                fontSize="20"
                fill="black"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="bold"
              >
                <tspan x={roomCenter.centerX} dy="-0.8em">
                  {unit}
                </tspan>
                <tspan x={roomCenter.centerX} dy="2em">
                  {room}
                </tspan>
              </text>
            )
          );
        })}
      </svg>
    </div>
  );
}

export default ApartmentBlock1;
